/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowTemplateStepsControllerFindOneQueryResponse, WorkflowTemplateStepsControllerFindOnePathParams, WorkflowTemplateStepsControllerFindOneQueryParams, WorkflowTemplateStepsControllerFindOne400, WorkflowTemplateStepsControllerFindOne401, WorkflowTemplateStepsControllerFindOne403, WorkflowTemplateStepsControllerFindOne404 } from "../../models/workflowsController/WorkflowTemplateStepsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { workflowTemplateStepsControllerFindOne } from "../../clients/workflowsService/workflowTemplateStepsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const workflowTemplateStepsControllerFindOneQueryKey = (id: WorkflowTemplateStepsControllerFindOnePathParams["id"], params: WorkflowTemplateStepsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/workflow-template-steps/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type WorkflowTemplateStepsControllerFindOneQueryKey = ReturnType<typeof workflowTemplateStepsControllerFindOneQueryKey>;
export function workflowTemplateStepsControllerFindOneQueryOptions(id: WorkflowTemplateStepsControllerFindOnePathParams["id"], params?: WorkflowTemplateStepsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = workflowTemplateStepsControllerFindOneQueryKey(id, params);
  return queryOptions<WorkflowTemplateStepsControllerFindOneQueryResponse, ResponseErrorConfig<WorkflowTemplateStepsControllerFindOne400 | WorkflowTemplateStepsControllerFindOne401 | WorkflowTemplateStepsControllerFindOne403 | WorkflowTemplateStepsControllerFindOne404>, WorkflowTemplateStepsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return workflowTemplateStepsControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a workflow template step by id
 * {@link /api/v1/workflow-template-steps/:id}
 */
export function useWorkflowTemplateStepsControllerFindOne<TData = WorkflowTemplateStepsControllerFindOneQueryResponse, TQueryData = WorkflowTemplateStepsControllerFindOneQueryResponse, TQueryKey extends QueryKey = WorkflowTemplateStepsControllerFindOneQueryKey>(id: WorkflowTemplateStepsControllerFindOnePathParams["id"], params?: WorkflowTemplateStepsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<WorkflowTemplateStepsControllerFindOneQueryResponse, ResponseErrorConfig<WorkflowTemplateStepsControllerFindOne400 | WorkflowTemplateStepsControllerFindOne401 | WorkflowTemplateStepsControllerFindOne403 | WorkflowTemplateStepsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? workflowTemplateStepsControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...workflowTemplateStepsControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<WorkflowTemplateStepsControllerFindOne400 | WorkflowTemplateStepsControllerFindOne401 | WorkflowTemplateStepsControllerFindOne403 | WorkflowTemplateStepsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}